// Small utilities shared across the app
// `cn` is a lightweight className helper similar to `clsx`/`classnames`.
// It accepts strings, numbers, arrays and objects and returns a single string
// with truthy class names joined by spaces.

export type ClassValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | ClassDictionary
  | ClassArray

interface ClassDictionary {
  [key: string]: any
}

interface ClassArray extends Array<ClassValue> {}

export function cn(...args: ClassValue[]): string {
  const classes: string[] = []

  const add = (value: ClassValue) => {
    if (!value && value !== 0) return

    if (typeof value === "string" || typeof value === "number") {
      classes.push(String(value))
      return
    }

    if (Array.isArray(value)) {
      value.forEach(add)
      return
    }

    if (typeof value === "object") {
      for (const [key, val] of Object.entries(value as ClassDictionary)) {
        if (val) classes.push(key)
      }
      return
    }
  }

  args.forEach(add)
  return classes.join(" ")
}

export default cn
